import BaseService from './base.service';

export default class DeviceTypesService {
    static ENDPOINT = '/device-types';

    static async getDeviceTypes() {
        return BaseService.get(this.ENDPOINT);
    }
}
